import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './VideoStyles.css';

import spaceVideo from '../assets/business.mp4';
import secondVideo from '../assets/video2.mp4';  // Import the second video
import thirdVideo from '../assets/video3.mp4';   // Import the third video
import brochure from '../assets/brochure.pdf';   // Import your PDF

const videos = [spaceVideo, secondVideo, thirdVideo]; // Array of video sources

const Video = () => {
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const videoRef = useRef(null);

    useEffect(() => {
        const videoElement = videoRef.current;

        const handleVideoEnded = () => {
            setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
        };

        videoElement.addEventListener('ended', handleVideoEnded);

        return () => {
            videoElement.removeEventListener('ended', handleVideoEnded);
        };
    }, []);

    useEffect(() => {
        // Update the video source whenever the current video index changes
        const videoElement = videoRef.current;
        videoElement.src = videos[currentVideoIndex];
        videoElement.play(); // Auto play the next video
    }, [currentVideoIndex]);

    return (
        <div className='hero'>
            <video autoPlay muted id='video' ref={videoRef}>
                <source src={videos[currentVideoIndex]} type='video/mp4' />
            </video>
            <div className='content'>
                <h1>AFRICA MINING SUMMIT</h1>
                <h1>INVESTMENT 2024</h1>
                <p>Provincial Workshops Empowering Africa's Mining Industry</p>
                <div>
                    {/* Update the "Brochure" button to download the PDF */}
                    <a href={brochure} className='btn' download>Brochure</a>
                    <Link to='/pricing' className='btn btn-light'>Register Now</Link>
                </div>
            </div>
        </div>
    );
}

export default Video;
